import { X } from 'lucide-react';

import { Source, SourceId } from '@/react/portainer/gitops/sources/types';

import { PortainerSelect } from '@@/form-components/PortainerSelect';
import { Widget } from '@@/Widget';
import { Button } from '@@/buttons';

export function EmptySourceSlot({
  options,
  onSelect,
  onRemove,
  slotId,
}: {
  options: Array<Source>;
  onSelect: (sourceId: SourceId) => void;
  onRemove?: () => void;
  slotId: string;
}) {
  return (
    <Widget>
      <Widget.Taskbar className="flex items-center gap-2">
        <PortainerSelect<SourceId | undefined>
          inputId={`workflow-source-select-${slotId}`}
          data-cy={`workflow-source-select-${slotId}`}
          aria-label="Select a source"
          placeholder="Select a source..."
          value={undefined}
          options={options.map((source) => ({
            value: source.id,
            label: source.name,
          }))}
          onChange={(sourceId) => {
            if (sourceId) {
              onSelect(sourceId);
            }
          }}
          noOptionsMessage={() => 'No more sources to add'}
        />
        {onRemove && (
          <Button
            type="button"
            color="dangerlight"
            size="xsmall"
            icon={X}
            onClick={onRemove}
            aria-label="Remove source"
            data-cy="workflow-remove-empty-source-button"
          />
        )}
      </Widget.Taskbar>
    </Widget>
  );
}
